import hexToRgba from 'hex-rgba'
import generateBreakPoints from 'react-jss-grid/utils/breakpoints'
import constants from './constants'

const padding = [0, '80px']
const paddingMobile = [0, '20px']

export const sizes = {
  xs: 575,
  sm: 576,
  md: 720,
  lg: 992,
  xl: 1025,
  xxl: 1260,
}
const media = {
  xs: `@media (max-width: ${sizes.sm - 1}px)`,
  sm: `@media (min-width: ${sizes.sm}px)`,
  md: `@media (min-width: ${sizes.md}px)`,
  lg: `@media (min-width: ${sizes.lg}px)`,
  xl: `@media (min-width: ${sizes.xl}px)`,
  xxl: `@media (min-width: ${sizes.xxl}px)`,
}
const mediaInverse = {
  xs: `@media (max-width: ${sizes.sm - 1}px)`,
  sm: `@media (max-width: ${sizes.md - 1}px)`,
  md: `@media (max-width: ${sizes.lg - 1}px)`,
  lg: `@media (max-width: ${sizes.xl - 1}px)`,
  xl: `@media (max-width: ${sizes.xxl - 1}px)`,
  xxl: `@media (min-width: ${sizes.xxl}px)`,
  smLand: `@media (max-width: ${sizes.md - 1}px) and (orientation: landscape)`,
}

const colors = [
  '#41403D', // #0 Dark
  '#ffffff', // #1 Bianco
  '#000000', // #2 Nero
  '#f5f5f5', // #3 Grigio chiaro
  '#B97052', // #4 Terracotta
  '#dcd2ea', // #5 Pink
  '#547779', // #6 Green
  '#757b8a', // #7 Viola
  '#e5e5e5', // #8 Grigio scuro
  '#707070', // #9 Grigio alt
  '#eac02d', // #10 Giallino
  '#ced5ab', // #11 Lime
  '#336598', // #12
]

const fonts = [
  '"Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif', // [0]
  '"Cako-Black", "Helvetica Neue", Helvetica, Arial, sans-serif', // [1]
  '"Cako-Regular", "Helvetica Neue", Helvetica, Arial, sans-serif', // [2]
]

const easings = {
  'power3.out': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)', // [0]
  'power3.inOut': 'cubic-bezier( 0.645,  0.045,  0.355,  1.000 )', // [1]
  'power4.out': 'cubic-bezier(0.76, 0, 0.24, 1)', // [2]
}

const general = {
  fontFamily: fonts[0],
  fontSize: 16,
  lineHeight: 1.333,
  color: colors[4],
}

const zindex = {
  overlay: 97,
  mainNav: 99,
  collectionNav: 98,
  header: 100,
  cursor: 102,
  modal: 103,
  cookiebar: 300,
}

const headings = {
  fontFamily: fonts[1],
  fontWeight: 'normal',
  lineHeight: 1.2,
  margin: 0,
  padding: 0,
  color: colors[3],
  '& strong, & b': {
    fontWeight: 'bold',
  },
  '& p': {
    margin: 0,
  },
}

const typography = {
  general: {
    extend: general,
  },
  headings: {
    extend: headings,
  },
  button: {
    fontSize: 12,
    letterSpacing: 1,
    textTransform: 'uppercase',
    display: 'inline-block',
    padding: '10px 30px',
    borderRadius: 20,
    color: colors[1],
    background: colors[2],
    verticalAlign: 'middle',
    transition: `background .3s ${easings['power4.out']}, color .3s ${easings['power4.out']}`,
    cursor: 'pointer',
    '& span': {
      display: 'inline-block',
    },
  },
  buttonMobile: {
  },
}

const wrapper = {
  padding: [0, '7vw'],
}

const flex = {
  verticalCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  horizontalCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
}

export const theme = {
  IMAGE_URL: `${constants.urls.SITE}wp-content/themes/${constants.config.THEME_NAME}/images/`,
  AUDIO_URL: `${constants.urls.SITE}wp-content/themes/${constants.config.THEME_NAME}/audio/`,
  media,
  mediaInverse,
  colors,
  zindex,
  wrapper,
  easings,
  fonts,
  typography,
  detect: {
    hasTouchWin: navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1,
    hasPointer: !!window.navigator.msPointerEnabled,
    hasTouch: 'ontouchstart' in document,
    isIos: !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
    isIphone: !!navigator.platform && /iPhone/.test(navigator.platform),
    isSafari: navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1,
    isIE11: !!window.MSInputMethodContext && !!document.documentMode,
    isNativeScroll: ('ontouchstart' in document && window.innerWidth <= 1280) || (!!window.MSInputMethodContext && !!document.documentMode), // (hasTouch && winW <= 1280) || isIE11
    // isNativeScroll: true,
    dom2webgl: !(!!window.MSInputMethodContext && !!document.documentMode) && !('ontouchstart' in document && window.innerWidth <= 1280), // Non IE11 e Non touch con larghezza > 1280
  },
  maxWidth: 1600,
  padding,
  paddingMobile,
  header: {
    top: 30,
    bottom: 40,
    height: 55,
    // spacing: [9, 20, 0],
    logo: {
      width: 101,
      height: 18,
    },
    burger: {
      wrap: '40px',
      height: '28px',
    },
    searchWidth: 120,
  },
  animations: {
    ease: 'cubic-bezier(0.650, 0.075, 0.400, 0.935)',
    time: '0.6s',
  },
  getRgba: (col, opacity) => hexToRgba(col, opacity * 100),
  breakpoints: generateBreakPoints({
    values: sizes,
  }),
  flex,
}
